import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { PairToken } from '@app/types/pool';
import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { PositionsListHeader } from '@app/screens/positions/components/PositionsListHeader';
import { useNitroPositionsList } from '@app/hooks/nitro/useNitroPositionsList';
import { NoKpNftView } from '@app/screens/positions/components/NoKpNftView';
import { PositionsFilters } from '@app/screens/positions/components/PositionsFilters';
import { SpNftPositionsListRowItem } from '@app/screens/positions/components/SpNftPositionListRowItem';
import { useKpNftPositions } from '@app/hooks/nft/useKpNftPositions';

import s from './SpNftsList.module.scss';
import { AnimatePresence } from 'framer-motion';
import { StaggeredList } from '@app/components/StaggeredList';

export const SpNftsList = () => {
  const { data: stakedToNitroPositions } = useNitroPositionsList();

  const { data: kpNftPositions, isLoading } = useKpNftPositions();

  const mergedData = useMemo(() => {
    return [
      ...(stakedToNitroPositions ?? []).map(pos => {
        return {
          data: pos,
          isStakedToNitro: true,
          nitroPoolId: pos.pool.id,
          poolAddress: pos.pool.nftPool,
          lpToken: pos.lpToken
        };
      }),
      ...(kpNftPositions ?? []).map(pos => {
        return {
          data: pos,
          isStakedToNitro: false,
          nitroPoolId: undefined,
          poolAddress: pos.nftPool.id,
          lpToken: pos.nftPool.lpToken
        };
      })
    ];
  }, [kpNftPositions, stakedToNitroPositions]);

  function renderList() {
    if (isLoading) {
      return <ListLoader />;
    }

    if (!mergedData || mergedData.length === 0) {
      return <NoKpNftView />;
    }

    return (
      <AnimatePresence>
        <StaggeredList once={false}>
          {mergedData?.map(pos => {
            const {
              data: item,
              isStakedToNitro,
              nitroPoolId,
              poolAddress,
              lpToken
            } = pos;

            return (
              <SpNftPositionsListRowItem
                key={item.tokenId}
                poolAddress={poolAddress}
                tokenId={item.tokenId}
                tokenDetails={lpToken as PairToken}
                isStakedToNitro={isStakedToNitro}
                nitroPoolId={nitroPoolId}
              />
            );
          })}
        </StaggeredList>
      </AnimatePresence>
    );
  }

  return (
    <Box
      p={[0, '0 24px 24px']}
      borderRadius="16px"
      bg={['transparent', 'gray.3']}
      border={['none', '1px solid #232323']}
    >
      <Box className={s.container}>
        <PositionsFilters />
        <PositionsListHeader />
        {renderList()}
      </Box>
    </Box>
  );
};
